var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgXClose = function SvgXClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7 1.7L22.3.3 12 10.6 1.7.3.3 1.7 10.6 12 .3 22.3l1.4 1.4L12 13.4l10.3 10.3 1.4-1.4L13.4 12 23.7 1.7z",
    fill: "#333"
  })));
};

export default SvgXClose;